import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';

const Login = ({ onLoggedIn }) => {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [searchParams] = useSearchParams();

  // Check for error message in URL parameters
  useEffect(() => {
    const urlError = searchParams.get('error');
    if (urlError === 'invalid_token') {
      setError('Your email link has expired or is invalid. Please log in with your username and password.');
    }
  }, [searchParams]);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await axios.post('/api/auth/login', { username: identifier, password });
      onLoggedIn?.(res.data.user);
    } catch (err) {
      setError('Invalid username or password');
    }
  };

  return (
    <div className="container d-flex align-items-center justify-content-center full-height-container">
      <div className="login-container">
        <h1 className="text-center mb-4">Wire News Digest</h1>
        <form onSubmit={submit} className="border rounded p-4 bg-white shadow-sm">
          {error && <div className="alert alert-danger py-2">{error}</div>}
          <div className="mb-3">
            <label className="form-label">Username or Email</label>
            <input className="form-control" value={identifier} onChange={e=>setIdentifier(e.target.value)} />
          </div>
          <div className="mb-3">
            <label className="form-label">Password</label>
            <input type="password" className="form-control" value={password} onChange={e=>setPassword(e.target.value)} />
          </div>
          <button type="submit" className="btn btn-primary w-100">Login</button>
        </form>
      </div>
    </div>
  );
};

export default Login;

